
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    return {
      avatar: myApp.avatar(),
      lng: {},
      userLoggedIn: myApp.user.id,
      isIOS: this.$app.device.ios,
      isCordova: this.$app.device.cordova,
      captions: {
        restaurant: 'Restaurant',
        bar: 'Bar Pub',
        beach: 'Beach Spa',
        disco: 'Nightlife'
      },
      promo_text: ''
    };
  },
  mounted: function () {
    const self = this,
          $ = this.$,
          app = this.$app; // accetta termini e condizioni

    if (!localStorage.termsAndConditions) {
      window.setTimeout(() => {
        self.$setState({
          lng: window.lng
        }, () => {
          app.popup.open('.popup-terms-and-conditions');
          $('.popup-terms-and-conditions').on('popup:close', () => {
            self.openPopupSubscribe();
          });
        });
      }, 5000);
    } else {
      this.openPopupSubscribe();
    }

    $('.popup-poi-completi').on('popup:open', () => {
      self.$setState({
        lng: lng
      }, () => {
        myApp.server.get('imc/promo_text').then(t => {
          self.$setState({
            promo_text: t[lng.language]
          });
        }).catch(err => console.log(err));
      });
    });
    $('.panel-left').on('panel:open', () => {
      self.$setState({
        lng: window.lng,
        userLoggedIn: myApp.user.id,
        avatar: myApp.avatar()
      });
    });
    $('.panel-right').on('panel:open', () => {
      self.$setState({
        lng: window.lng
      });
      $('.panel-right-caption').text(self.captions[self.$root.type]);
    });
    let range = app.range.create({
      el: '.lgbtq'
    });
    range.on('change', e => {
      switch (e.value) {
        case -1:
          $('.lgbtq-no').addClass('lgbt-selected');
          $('.lgbtq-yes').removeClass('lgbt-selected');
          $('.lgbt-neutral').removeClass('lgbt-selected');
          break;

        case 0:
          $('.lgbtq-no').removeClass('lgbt-selected');
          $('.lgbtq-yes').removeClass('lgbt-selected');
          $('.lgbt-neutral').addClass('lgbt-selected');
          break;

        case 1:
          $('.lgbtq-no').removeClass('lgbt-selected');
          $('.lgbtq-yes').addClass('lgbt-selected');
          $('.lgbt-neutral').removeClass('lgbt-selected');
          break;
      }
    });
    $('.number-key').click(ev => {
      const el = $(ev.target);
      self.keynumber = self.keynumber || [];

      switch (el.data('number')) {
        case 'null':
          break;

        case 'back':
          console.log('back', self.keynumber.length);

          if (self.keynumber.length) {
            console.log('pop');
            self.keynumber.pop();
            console.log(self.keynumber, self.keynumber.length);
          }

          break;

        default:
          if (self.keynumber.length == 5) {
            console.log(self.keynumber);
          } else if (self.keynumber.length == 4) {
            self.keynumber.push(el.data('number'));
            console.log(self.keynumber);
            self.emailInsertCode();
          } else {
            self.keynumber.push(el.data('number'));
            console.log(self.keynumber);
          }

      }

      $('.point').removeClass('point-fill');
      self.keynumber.forEach((e, i) => {
        $('.point-' + i).addClass('point-fill');
      });
    });
  },
  methods: {
    accepttermsAndConditions() {
      const self = this,
            app = this.$app,
            $ = this.$;

      if ($('#termsAndConditions').prop('checked')) {
        localStorage.termsAndConditions = 'OK';
        app.popup.close('.popup-terms-and-conditions');
      } else {
        app.dialog.alert(lng.iAgreeError);
      }
    },

    contestInfo() {
      const url = 'https://infomycity.com/concorso/?u=' + myApp.user.id + '&l=' + lng.language;

      if (window.cordova) {
        const opt = 'location=no,toolbar=no,toolbarcolor=#ffffff,closebuttoncolor=#007aff' + ',hardwareback=no,hidenavigationbuttons=yes,zoom=no';
        const ref = cordova.InAppBrowser.open(url, '_blank', opt); // cattura evento 'close'

        ref.addEventListener('loadstart', function (event) {
          console.log('event.url: ' + event.url);

          if (event.url.match("close")) {
            ref.close();
          }
        });
      } else {
        window.open(url);
      }
    },

    lgbtq(value) {
      this.$app.range.get('.lgbtq').setValue(value);
    },

    otherFilters() {
      this.$app.popup.open('.popup-other-filters');
    },

    socialSharing(type) {
      const self = this;
      const url = 'https://infomycity.com/share/?u=' + myApp.user.id + '&l=' + lng.language;
      var accept = false;

      if (window.cordova) {
        const opt = 'location=no,toolbar=no,toolbarcolor=#ffffff,closebuttoncolor=#007aff' + ',hardwareback=no,hidenavigationbuttons=yes,zoom=no';
        const ref = cordova.InAppBrowser.open(url, '_blank', opt); // cattura evento 'close'

        ref.addEventListener('loadstart', function (event) {
          console.log('event.url: ' + event.url);

          if (event.url.match("close")) {
            ref.close();
          } else if (event.url.match("accept")) {
            accept = true;
            ref.close();
          }
        });
        ref.addEventListener('exit', () => {
          if (accept) {
            self.socialSharing2(type);
          }
        });
      } else {
        window.open(url);
      } //console.log(type);
      //myApp.cordova.socialShare(type);

    },

    socialSharing2(type) {
      myApp.cordova.socialShare(type);
    },

    logout() {
      self = this;
      this.$app.dialog.confirm(lng.exitAlert, () => {
        localStorage.clear();
        myApp.chatlist = null;
        myApp.server.token('');
        myApp.user = {};
        self.$setState({
          avatar: 'static/avatar-1.svg',
          userLoggedIn: false
        });
        myApp.refreshHome();
      });
    },

    filter() {
      myApp.filter();
    },

    loginFacebook() {
      const self = this,
            app = this.$app;
      myApp.cordova.facebookLogin().then(res => {
        self.registryUser(res);

        if (!self.checkUserData(res)) {
          console.log('Dati registazione incompleti');
          app.views.main.router.navigate('/profile/');
        }
      }).catch(err => {
        console.log(err); //app.dialog.alert(lng.errorGeneric);
      });
      app.panel.close();
    },

    loginGoogle() {
      const self = this,
            app = this.$app;
      myApp.cordova.googleLogin().then(res => {
        self.registryUser(res);

        if (!self.checkUserData(res)) {
          console.log('Dati registazione incompleti');
          app.views.main.router.navigate('/profile/');
        }
      }).catch(err => {
        console.log(err);
      });
      app.panel.close();
    },

    appleLogin() {
      const self = this,
            app = this.$app;

      if (app.device.osVersion.split('.')[0] * 1 < 13) {
        return app.toast.show({
          text: 'iOS >= 13 is required',
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      }

      myApp.cordova.appleLogin().then(res => {
        self.registryUser(res);

        if (!self.checkUserData(res)) {
          app.views.main.router.navigate('/profile/');
        }
      }).catch(err => {
        console.log(err);
        app.dialog.alert(lng.errorGeneric);
      });
      app.panel.close();
    },

    emailLogin() {
      this.$app.loginScreen.open('.login-screen');
    },

    emailResendCode() {
      const self = this;
      const email = this.$('#loginEmailFormEmail').val();
      myApp.server.post('imc/resendcode', {
        email: email,
        verify_id: myApp.loginEmailVerifyData.verify_id
      }).then(() => {
        self.$app.dialog.alert(lng.resendEmailMessageOK.replace('$email$', email));
      }).catch(err => {
        console.log(err);
        self.$app.toast.show({
          text: lng.genericError,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      });
    },

    emailSignIn() {
      const self = this,
            app = this.$app,
            $ = this.$,
            email = $('#loginEmailFormEmail').val();
      myApp.server.post('imc/emailogin', {
        email: email
      }).then(resp => {
        $('.email-content').addClass('hidden');
        $('.signInButtonContent').addClass('hidden');
        $('.code-content').removeClass('hidden');
        $('.insertCodeButtonContent').removeClass('hidden');
        $('.imc-logo').addClass('hidden');
        $('.login-info').html(lng.resendEmailMessageOK.replace('$email$', email));
        myApp.loginEmailVerifyData = resp;
        self.keynumber = [];
        $('.point').removeClass('point-fill'); // interval 

        myApp.loginEmailInterval = window.setInterval(function () {
          myApp.server.post('imc/emailverify', resp).then(succ => {
            window.clearInterval(myApp.loginEmailInterval);
            $('.email-content').removeClass('hidden');
            $('.imc-logo').removeClass('hidden');
            $('.signInButtonContent').removeClass('hidden');
            $('.code-content').addClass('hidden');
            $('.insertCodeButtonContent').addClass('hidden');
            $('.login-info').html('');
            app.loginScreen.close();
            app.panel.close();
            self.registryUser(succ);

            if (!self.checkUserData(succ)) {
              // apro pagina di registrazione
              console.log('Dati registazione incompleti');
              app.views.main.router.navigate('/profile/');
            }
          }).catch(err => {
            console.log(err);
          });
        }, 3000);
      }).catch(err => {
        console.log(err);
      });
    },

    emailInsertCodeCancel() {
      const $ = this.$;
      window.clearInterval(myApp.loginEmailInterval);
      $('.email-content').removeClass('hidden');
      $('.signInButtonContent').removeClass('hidden');
      $('.code-content').addClass('hidden');
      $('.insertCodeButtonContent').addClass('hidden');
      $('.login-info').html('');
      this.$app.loginScreen.close('.login-screen');
      self.keynumber = [];
      $('.point').removeClass('point-fill');
    },

    emailInsertCode() {
      const $ = this.$,
            app = this.$app,
            self = this,
            data = myApp.loginEmailVerifyData,
            verify_code = self.keynumber.join(''); // this.$('#loginEmailFormCode').val();

      if (!verify_code) return;
      myApp.server.post('imc/emailverify', {
        email: data.email,
        verify_id: data.verify_id,
        verify_code: verify_code
      }).then(succ => {
        console.log(succ);
        window.clearInterval(myApp.loginEmailInterval);
        self.keynumber = [];
        $('.point').removeClass('point-fill');
        $('.email-content').removeClass('hidden');
        $('.signInButtonContent').removeClass('hidden');
        $('.code-content').addClass('hidden');
        $('.insertCodeButtonContent').addClass('hidden');
        $('.login-info').html('');
        app.loginScreen.close();
        app.panel.close();
        self.registryUser(succ);

        if (!self.checkUserData(succ)) {
          app.views.main.router.navigate('/profile/');
        }
      }).catch(err => {
        app.toast.show({
          text: lng.errorCode,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
        console.log(err);
      });
    },

    checkUserData(data) {
      if (!data.name || !data.lastname || !data.sex || !data.birthdate) return false;
      if (data.birthdate === '0000-00-00') return false;
      return true;
    },

    registryUser(data) {
      localStorage.user = JSON.stringify(data);
      myApp.user = data;
      myApp.server.token(data.id);
      myApp.refreshHome();
    },

    openPopupSubscribe() {
      if (myApp.user.id || myApp.openPopupSubscribe) return;
      setTimeout(() => {
        this.$setState({
          lng: window.lng
        });
        const l = lng.language;
        const show = myApp.messages[l].mostraConcorso;
        if (!show) return;
        this.$('.popup-signin-message').html(myApp.messages[l].iscrivitiEPartecipa);
        this.$app.popup.open('.popup-signin');
      }, 5000);
    },

    downloadManager() {
      const url = this.$app.device.ios ? 'https://apps.apple.com/app/id1531101519' : 'https://play.google.com/store/apps/details?id=com.infomycity.imcmanager';

      if (window.cordova) {
        cordova.InAppBrowser.open(url, '_system', 'location=yes');
      } else {
        window.open(url);
      }
    },

    toggleOfferDates(ev) {
      if (ev.target.checked) {
        this.$('#only-offers-dates').removeClass('hidden');
      } else {
        this.$('#only-offers-dates').addClass('hidden');
      }
    }

  },
  id: '4bfcab3e0c',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div id="app">\n    <!-- Left panel with cover effect-->\n    <div class="panel panel-left panel-cover panel-init text-align-center bg-color-imc text-color-white">\n      <div style="height: 20px"></div>\n      <div class="profile-image" style="background-image:url(';
      r += c(ctx_1.avatar, ctx_1);
      r += ')"></div>\n\n      ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.userLoggedIn, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div class="panel-list-container">\n        <div class="list bg-color-imc mt-0">\n          <ul class="bg-color-imc margin-bottom">\n            <li>\n              <a href="/profile/" class="item-link no-chevron panel-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons text-color-primary">person</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      ';
          r += c(ctx_2.lng.profile, ctx_2);
          r += '\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n            <li>\n              <a href="/chatlist/" class="item-link no-chevron panel-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons text-color-primary">chat_bubble_text</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      Chat\n                    </div>\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, "myApp.badge.chat", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="item-after">\n                      <span class="badge bg-color-red text-color-white">';
              r += Template7Helpers.js.call(ctx_3, "myApp.badge.chat", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span>\n                    </div>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                  </div>\n                </div>\n              </a>\n            </li>\n            <li>\n              <a href="/bookings/" class="item-link no-chevron panel-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons text-color-primary">checkmark_alt</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      ';
          r += c(ctx_2.lng.activeBookings, ctx_2);
          r += '\n                    </div>\n\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, "myApp.badge.bookings", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="item-after">\n                      <span class="badge bg-color-red text-color-white">';
              r += Template7Helpers.js.call(ctx_3, "myApp.badge.bookings", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span>\n                    </div>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                  </div>\n                </div>\n              </a>\n            </li>\n            <li>\n              <a href="/myorders/" class="item-link no-chevron panel-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons text-color-primary">cart</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      ';
          r += c(ctx_2.lng.myOrders, ctx_2);
          r += '\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n            <l>&nbsp;</l>\n            ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.isCordova, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <li>\n              <a href="#" @click="socialSharing(\'friend\')" class="item-link no-chevron panel-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons text-color-primary">person_3_fill</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      ';
              r += c(ctx_3.lng.inviteAFriend, ctx_3);
              r += '\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="socialSharing(\'poi\')" class="item-link no-chevron panel-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <img width="28" src="static/menu/restaurant_icon.png">\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      ';
              r += c(ctx_3.lng.inviteAPOI, ctx_3);
              r += '\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="contestInfo" class="item-link no-chevron panel-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons text-color-primary">info_circle</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      CashCredits\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            <li>\n              <a href="/legalinfo/" class="item-link no-chevron panel-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons text-color-primary">info</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      ';
          r += c(ctx_2.lng.poiLegalInformations, ctx_2);
          r += '\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n            <li>&nbsp;</li>\n            <li>\n              <a href="#" @click="logout" class="item-link text-color-gray no-chevron panel-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons text-color-gray" style="font-size: 1.5rem">power</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      Logout\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n\n      ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.isCordova, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += Template7Helpers.if.call(ctx_3, ctx_3.isIOS, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div class="block">\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.isCordova, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <p>\n          <button @click="loginFacebook" class="signInButton signInFacebook">\n            <div class="float-left"><i class="f7-icons">logo_facebook</i> </div>\n            ';
              r += c(ctx_3.lng.signUpUsingFacebook, ctx_3);
              r += '\n          </button>\n        </p>\n        <p>\n          <button @click="loginGoogle" class="signInButton signInGoogle">\n            <div class="float-left"><i class="f7-icons">logo_google</i> </div>\n            ';
              r += c(ctx_3.lng.signUpUsingGoogle, ctx_3);
              r += '\n          </button>\n        </p>\n        ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.isIOS, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n        <p>\n          <button @click="appleLogin" class="signInButton signInApple">\n            <div class="float-left"><i class="f7-icons">logo_apple</i> </div>\n            Sign in with Apple\n          </button>\n        </p>\n        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        <p>\n          <button @click="emailLogin" class="signInButton signInEmail">\n            <div class="float-left"><i class="f7-icons">at</i> </div>\n            ';
          r += c(ctx_2.lng.signUpUsingEmail, ctx_2);
          r += '\n          </button>\n        </p>\n      </div>\n      ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n    </div>\n\n    <!-- Panel right -->\n    <div class="panel panel-right panel-cover bg-color-white text-color-imc">\n      <div class="block">\n        <h1 class="text-align-center text-capitalize panel-right-caption"></h1>\n        <div class="list mt-0">\n          <ul>\n            <li class="padding-top">\n              <label class="toggle">\n                <input class="with-promo" @change="toggleOfferDates" type="checkbox">\n                <span class="toggle-icon"></span>\n              </label>\n              <span>Only Time Out</span>\n            </li>\n            <li style="font-size: 14px; padding-top: 5px; padding-left: 15px; margin-bottom: -5px; text-transform: capitalize">\n              ';
      r += c(ctx_1.lng.onlyOffers, ctx_1);
      r += '\n            </li>\n\n\n            <li id="only-offers-dates" class="hidden">\n              <ul style="padding-left: 30px; font-size: .85em">\n                <li>\n                  <label class="item-radio item-content">\n                    <input type="radio" name="offers-date" checked value="today"/>\n                    <i class="icon icon-radio"></i>\n                    <div class="item-inner">\n                      <div class="item-title">';
      r += c(ctx_1.lng.today, ctx_1);
      r += '</div>\n                    </div>\n                  </label>\n                </li>\n                <li>\n                  <label class="item-radio item-content">\n                    <input type="radio" name="offers-date" value="tomorrow"/>\n                    <i class="icon icon-radio"></i>\n                    <div class="item-inner">\n                      <div class="item-title">';
      r += c(ctx_1.lng.tomorrow, ctx_1);
      r += '</div>\n                    </div>\n                  </label>\n                </li>\n                <li>\n                  <label class="item-radio item-content">\n                    <input type="radio" name="offers-date" value="day-after-tomorrow"/>\n                    <i class="icon icon-radio"></i>\n                    <div class="item-inner">\n                      <div class="item-title">';
      r += c(ctx_1.lng.dayAfterTomorrow, ctx_1);
      r += '</div>\n                    </div>\n                  </label>\n                </li>\n                <li>\n                  <label class="item-radio item-content">\n                    <input type="radio" name="offers-date" value="within-10-days"/>\n                    <i class="icon icon-radio"></i>\n                    <div class="item-inner">\n                      <div class="item-title">';
      r += c(ctx_1.lng.within10Days, ctx_1);
      r += '</div>\n                    </div>\n                  </label>\n                </li>\n                <li>\n                  <label class="item-radio item-content">\n                    <input type="radio" name="offers-date" value="within-30-days"/>\n                    <i class="icon icon-radio"></i>\n                    <div class="item-inner">\n                      <div class="item-title">';
      r += c(ctx_1.lng.within30Days, ctx_1);
      r += '</div>\n                    </div>\n                  </label>\n                </li>\n                <li>\n                  <label class="item-radio item-content">\n                    <input type="radio" name="offers-date" value="calendar"/>\n                    <i class="icon icon-radio"></i>\n                    <div class="item-inner">\n                      <div class="item-title">Calendar</div>\n                    </div>\n                  </label>\n                  <input type="date" id="offers-date-calendar" placeholder="Insert date"/>\n                </li>\n              </ul>\n\n            </li>\n\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "../../type !== 'beach' && ../../type !== 'disco' && false", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <li class="padding-top">\n              <label class="toggle">\n                <input class="with-takeaway" type="checkbox">\n                <span class="toggle-icon"></span>\n              </label>\n              <span>';
          r += c(ctx_2.lng.onlyTakeAway, ctx_2);
          r += '</span>\n            </li>\n            <li class="padding-vertical">\n              <label class="toggle">\n                <input class="with-delivery" type="checkbox">\n                <span class="toggle-icon"></span>\n              </label>\n              <span>';
          r += c(ctx_2.lng.onlyDelivery, ctx_2);
          r += '</span>\n            </li>\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div style=\'height: 15px\'></div>\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </ul>\n        </div>\n        <button @click="otherFilters" class="button button-round mt-0">';
      r += c(ctx_1.lng.otherFilters, ctx_1);
      r += '</button>\n\n        <div class="list list-subtypes no-hairline-top">\n          <ul>\n            <li>\n              <label class="item-checkbox item-content">\n                <input type="checkbox" class="subcategories-all" value="all" checked="checked"/>\n                <i class="icon icon-checkbox"></i>\n                <div class="item-inner">\n                  <div class="item-title">\n                    ';
      r += c(ctx_1.lng.all, ctx_1);
      r += '\n                  </div>\n                </div>\n              </label>\n            </li>\n            ';
      r += Template7Helpers.each.call(ctx_1, root.subtypes, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            ';
          r += Template7Helpers.if.call(ctx_2, data_2 && data_2.index, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <li>\n              <label class="item-checkbox item-content">\n                <input type="checkbox" name="subcategories-checkbox" value="';
              r += c(data_3 && data_3.index, ctx_3);
              r += '" checked="checked"/>\n                <i class="icon icon-checkbox"></i>\n                <div class="item-inner">\n                  <div class="item-title">\n                    ';
              r += c(ctx_3, ctx_3);
              r += '\n                  </div>\n                </div>\n              </label>\n            </li>\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </ul>\n        </div>  \n      </div>\n      <a href="#" @click="filter" class="button \n         btn-search \n         button-large \n         button-fill \n         button-round \n         bg-imc \n         text-color-primary \n         link \n         panel-close">';
      r += c(ctx_1.lng.search, ctx_1);
      r += '</a>\n    </div>\n\n    <div class="login-screen">\n      <!-- Default view-page layout -->\n      <div class="view">\n        <div class="page login-screen-page"> \n          <div class="imc-logo" style="position: absolute; top: 10px; width:100vw; text-align: center">\n            <img width="20%" src="static/icon-512.png"/>\n            <br>\n            <img style="width: 50%" src="static/logo.png" alt=""/>\n          </div>\n          <!-- page-content has additional login-screen content -->\n          <div class="page-content login-screen-content">\n            <!-- Login form -->\n            <form>\n              <div class="list">\n                <ul>\n                  <li class="item-content item-input email-content">\n                    <div class="item-inner">\n                      <div class="item-title item-label">Email</div>\n                      <div class="item-input-wrap">\n                        <input type="email" name="email" id="loginEmailFormEmail" placeholder="Email">\n                        <span class="input-clear-button"></span>\n                      </div>\n                    </div>\n                  </li>\n                  <li class="item-content item-input code-content-old hidden">\n                    <div class="item-inner">\n                      <div class="item-title item-label">Code</div>\n                      <div class="item-input-wrap">\n                        <input type="tel" name="code" id="loginEmailFormCode" placeholder="Code">\n                        <span class="input-clear-button"></span>\n                      </div>\n                    </div>\n                  </li>\n                </ul>\n              </div>\n              <div class="list">\n                <ul>\n                  <li class="signInButtonContent">\n                    <a href="#" @click="emailSignIn" class="list-button text-color-imc">Sign In</a>\n                  </li>\n                  <li class="insertCodeButtonContent- hidden">\n                    <a href="#" @click="emailInsertCode" class="list-button text-color-imc">Insert code</a>\n                  </li>\n                  <li class="insertCodeButtonContent- hidden">\n                    <a href="#" @click="emailResendCode" class="list-button text-color-red">Send code again</a>\n                  </li>\n                  <li>\n                    <a href="#" @click="emailInsertCodeCancel" class="list-button text-color-gray">Cancel</a>\n                  </li>\n                </ul>\n                <div class="block-footer login-info"></div>\n              </div>\n\n\n\n              <div class="code-content hidden unselectable">\n                <div class="row text-align-center" style="max-width: 250px; margin: 0 auto; padding: 25px 0">\n                  <div class="col">\n                    <div class="point point-0"></div>\n                  </div>\n                  <div class="col">\n                    <div class="point point-1"></div>\n                  </div>\n                  <div class="col">\n                    <div class="point point-2"></div>\n                  </div>\n                  <div class="col">\n                    <div class="point point-3"></div>\n                  </div>\n                  <div class="col">\n                    <div class="point point-4"></div>\n                  </div>\n                </div>\n                <div class="block text-align-center">\n                  <div class="row">\n                    <div class="col number-key" data-number="1">1</div>\n                    <div class="col number-key" data-number="2">2</div>\n                    <div class="col number-key" data-number="3">3</div>\n                  </div>\n                  <div class="row">\n                    <div class="col number-key" data-number="4">4</div>\n                    <div class="col number-key" data-number="5">5</div>\n                    <div class="col number-key" data-number="6">6</div>\n                  </div>\n                  <div class="row">\n                    <div class="col number-key" data-number="7">7</div>\n                    <div class="col number-key" data-number="8">8</div>\n                    <div class="col number-key" data-number="9">9</div>\n                  </div>\n                  <div class="row">\n                    <div class="col number-key" data-number="null"></div>\n                    <div class="col number-key" data-number="0">0</div>\n                    <div class="col number-key" data-number="back"><i class="f7-icons" data-number="back">delete_left</i></div>\n                  </div>\n                </div>\n              </div>\n\n              <a href="#" @click="emailResendCode" class="list-button text-color-red hidden insertCodeButtonContent">Send code again</a>\n\n\n\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <!-- popup otherFilters -->\n    <div class="popup popup-other-filters">\n      <div class="view">\n        <div class="page">\n          <div class="navbar bg-color-imc">\n            <div class="navbar-bg bg-color-imc"></div>\n            <div class="navbar-inner bg-color-imc">\n              <div class="title center sliding">';
      r += c(ctx_1.lng.otherFilters, ctx_1);
      r += '</div>\n              <div class="right">\n                <a class="link popup-close">\n                  <i class="icon f7-icons text-color-primary">multiply_circle_fill</i>\n                </a>\n              </div>\n            </div>\n          </div>\n\n          <div class="toolbar  toolbar-bottom" style="background: none; padding: 0">\n            <div class="toolbar-inner" style="padding:0; margin:0">\n              <a class="popup-close panel-close button button-large button-fill button-round bg-color-imc text-color-white margin-top"\n                 style="margin:0 auto 15px auto; width: 80%"\n                 href="#" @click="filter">\n                ';
      r += c(ctx_1.lng.search, ctx_1);
      r += '\n                <img width="22" src="static/check.png" alt=""/>\n              </a>\n            </div>\n          </div>\n\n          <div class="page-content bg-color-white">\n\n            <div class="list list-subtypes no-hairline-top">\n              <ul>\n                <li class="lgbt-container">\n                  <p class="text-align-center">LGBTQ friendly</p>\n                  <div class="text-align-center lgbt-neutral lgbt-selected" @click="lgbtq(0)">YES</div>\n                  <div class="row no-gap">\n                    <div class="col-30 text-align-center text-uppercase text-color-gray lgbtq-no" \n                         style="padding: 5px" \n                         @click="lgbtq(-1)">No</div>\n                    <div class="col-40">\n                      <div class="range-slider range-slider-min lgbtq range-init">\n                        <input type="range" min="-1" max="1" step="1" value="0">\n                      </div>\n                    </div>\n                    <div class="col-30 text-align-center text-uppercase text-color-gray lgbtq-yes"  \n                         style="font-size: 12px; margin-top: -3px" \n                         @click="lgbtq(1)">\n                      <img width="24" src="static/lgbt.png" alt=""/> <br> Only\n                    </div>\n                  </div>\n                  <hr style="border-top: solid 1px #ddd; border-bottom: none; margin-top: 15px">\n                </li>\n\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.lng.filters, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <li>\n                  <label class="item-checkbox item-content">\n                    <input type="checkbox" name="filters-checkbox" value="';
          r += c(data_2 && data_2.key, ctx_2);
          r += '" />\n                    <i class="icon icon-checkbox"></i>\n                    <div class="item-inner">\n                      <div class="item-title text-capitalize">\n                        ';
          r += c(ctx_2, ctx_2);
          r += '\n                      </div>\n                    </div>\n                  </label>\n                </li>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n              </ul>\n            </div>  \n          </div>\n        </div>\n      </div>\n    </div> <!-- /Popup Other Filters -->\n\n    <!-- Popup Iscriviti -->\n    <div class="popup popup-signin bg-color-imc" data-swipe-to-close="true">\n\n      <div class="display-flex justify-content-center flex-direction-column align-content-center h-100">\n        <div class="popup-signin-message"></div>\n        <p>\n          <a href="#" class="button link popup-close panel-open button-fill\n             button-round button-raised button-large margin text-color-imc" \n             data-panel=".panel-left">';
      r += c(ctx_1.lng.signUp, ctx_1);
      r += '</a>\n        </p>\n        <a href="#" class="button link popup-close">';
      r += c(ctx_1.lng.close, ctx_1);
      r += '</a>\n      </div>\n    </div>\n\n    <!-- Popup Termini e condizioni -->\n    <div class="popup popup-terms-and-conditions" data-close-by-backdrop-click="false">\n      <div class="display-flex flex-direction-column justify-content-center align-items-center h-100">\n        <img style="width: 70vw; max-width: 250px;" src="static/logo.png" alt=""/>\n        <p class="padding-horizontal text-align-justify">';
      r += c(ctx_1.lng.wellcomeMessage, ctx_1);
      r += '</p>\n        <div class="list simple-list" style="width:90%">\n          <ul>\n            <li>\n              <a class="external" target="_system" href="https://infomycity.com/documents/';
      r += c(ctx_1.lng.language, ctx_1);
      r += '/terms-and-conditions.html">';
      r += c(ctx_1.lng.termsAndConditions, ctx_1);
      r += '</a>\n            </li>\n            <li>\n              <a class="external" target="_system" href="https://infomycity.com/documents/';
      r += c(ctx_1.lng.language, ctx_1);
      r += '/privacy-policy.html">';
      r += c(ctx_1.lng.privacyPolicy, ctx_1);
      r += '</a>\n            </li>\n            <li>\n              <a class="external" target="_system" href="https://infomycity.com/documents/';
      r += c(ctx_1.lng.language, ctx_1);
      r += '/cookies.html">';
      r += c(ctx_1.lng.cookiesPolicy, ctx_1);
      r += '</a>\n            </li>\n            <li>\n              <span>Accetto</span>\n              <label class="toggle">\n                <input id="termsAndConditions" type="checkbox">\n                <span class="toggle-icon"></span>\n              </label>\n            </li>\n          </ul>\n        </div>\n        <button style="width: 70vw; max-width: 250px;" @click="accepttermsAndConditions"\n                class="button button-large button-fill button-round button-raised bg-color-imc text-color-primary">';
      r += c(ctx_1.lng.join, ctx_1);
      r += '</button>\n      </div>\n    </div>\n\n    <!-- popup Info Locali Completati -->\n    <div class="popup popup-poi-completi bg-color-white text-align-center" data-swipe-to-close="true">\n      <div class="display-flex flex-direction-column justify-content-center align-items-center h-100 padding-horizontal">\n        <p>';
      r += c(ctx_1.lng.onlyLocals1, ctx_1);
      r += '</p>\n        <p> \n          <img width="25" src="static/markers/restaurant.png" alt=""/>\n          <img width="25" src="static/markers/restaurant-gold-offer.png" alt=""/>\n          <img width="25" src="static/markers/bar.png" alt=""/>\n          <img width="25" src="static/markers/bar-gold-offer.png" alt=""/>\n          <img width="25" src="static/markers/beach.png" alt=""/>\n          <img width="25" src="static/markers/beach-gold-offer.png" alt=""/>\n          <img width="25" src="static/markers/disco.png" alt=""/>\n          <img width="25" src="static/markers/disco-gold-offer.png" alt=""/>\n        </p>\n        <p>';
      r += c(ctx_1.lng.onlyLocals2, ctx_1);
      r += '</p>\n\n        <p class="promo_text">';
      r += c(ctx_1.promo_text, ctx_1);
      r += '</p>\n\n        <button @click="downloadManager" class="link popup-close button external">';
      r += c(ctx_1.lng.download, ctx_1);
      r += ' Manager</button> \n      </div>\n    </div>\n\n    <!-- Your main view, should have "view-main" class -->\n    <div class="view view-main view-init safe-areas" data-url="/"></div>\n\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    